module.exports = __webpack_public_path__ + "media/images/shared/muevo_logo-7fb1cf28d857e8df3bdbc1a59482b720.png";